import { twMerge } from 'src/utils/tw-merge.util'
import { useTranslation } from 'react-i18next'
import { AdminOnlyBadge } from 'src/components/admin-only-badge.component'

interface PlanningTabActionsMenuProps {
  onUpdate: VoidFunction
  onDuplicate: VoidFunction
  onDelete?: VoidFunction
  className?: string
}

export const PlanningTabActionsMenu = ({
  onUpdate,
  onDuplicate,
  onDelete,
  className,
}: PlanningTabActionsMenuProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={twMerge(
        'c-absolute c-text-nowrap c-z-30 c-top-full c-right-0 c-bg-white c-border c-border-grey-600 c-rounded-md c-shadow-lg c-flex c-flex-col',
        className,
      )}
      role="menu"
    >
      <button
        className="c-px-4 c-py-2 hover:c-bg-secondary-300 c-text-left c-rounded-t-md c-flex c-items-center c-gap-1"
        onClick={onUpdate}
        role="menuitem"
      >
        <AdminOnlyBadge />
        {t('pages.planning.update-tab')}
      </button>
      <button
        className={twMerge(
          'c-px-4 c-py-2 hover:c-bg-secondary-300 c-text-left c-border-t c-border-grey-400 c-flex c-items-center c-gap-1',
          !onDelete && 'c-rounded-b-md',
        )}
        onClick={onDuplicate}
        role="menuitem"
      >
        <AdminOnlyBadge />
        {t('pages.planning.duplicate-tab')}
      </button>
      {onDelete && (
        <button
          className="c-px-4 c-py-2 hover:c-bg-secondary-300 c-text-left c-rounded-b-md c-border-t c-border-grey-400 c-flex c-items-center c-gap-1"
          onClick={onDelete}
          role="menuitem"
        >
          <AdminOnlyBadge />
          {t('pages.planning.remove-tab')}
        </button>
      )}
    </div>
  )
}
